module.exports = __webpack_public_path__ + "static/media/darwin-dashboard-logo02.ecd72d04.png";